<mat-list role="list" class="list-plantillas">
  <mat-list-item role="listitem" *ngFor="let item of lstJornadasFiltered">
    {{ item.IdJornada + ' - ' + item.Njornada}}
  </mat-list-item>
</mat-list>
